export default __webpack_public_path__ + "static/media/2122 cutlery side.36d660f4.png";